// validate object properties
function VO(obj: any, pattern?: any): boolean {
	const keys = pattern ? Object.keys(pattern) : Object.keys(obj);
	for (var k of keys) {
		if (
			(!obj[k] || obj[k] == null) &&
			typeof obj[k] !== "boolean" &&
			typeof obj[k] !== "object"
		) {
			return false;
		}
	}
	return true;
}

// Validate key
export function VK(obj: any): boolean {
	if (obj) return true;
	return false;
}

export function VN(name: string): boolean {
	/* validate full name */
	const wordCount = name.split(" ").filter((e) => e !== "").length;

	if (wordCount >= 2 && wordCount <= 3) return true;
	return false;
}

export function getUrlId(url: string) {
	const urlArray: string[] = url.split("/");
	return urlArray[urlArray.length - 1];
}

export function getUrlUserTestIds(url: string) {
	const urlArray: string[] = url.split("/");
	return {
		id_user:parseInt(urlArray[urlArray.length - 1]),
		id_test: parseInt(urlArray[urlArray.length - 2])
	} 
}

export function NotEmpty(array: any[] | undefined) {
	return array && array.length > 0;
}

export default VO;
